import React from "react";
import { useField } from "formik";
import FroalaTextEditor from "../FroalaTextEditor";
import { isHTMLEmpty, transformedText } from "../../../../utils/helpers";

const FormikFroalaTextEditor = ({
  name,
  id,
  onChange,
  onBlur,
  disabled,
  handleEditorSetup,
  handleEditorCustomization,
  editorRef,
  ...rest
}) => {
  const [field, meta, helpers] = useField(name);
  const { value } = field;
  const { touched, error } = meta;
  const { setValue, setTouched } = helpers;

  const handleChange = (text) => {
    //for validation, check if the transformed text is an empty string
    const isBlank = isHTMLEmpty(text);
    setValue(isBlank ? "" : text);
    if (onChange) {
      onChange(name, isBlank ? "" : text);
    }
  };

  const handleBlur = () => {
    setTouched(true);
    if (onBlur) onBlur(name, value);
  };

  return (
    <FroalaTextEditor
      name={name}
      id={id}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      handleEditorSetup={handleEditorSetup}
      handleEditorCustomization={handleEditorCustomization}
      editorRef={editorRef}
      {...rest}
    />
  );
};

export default FormikFroalaTextEditor;
